import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100/70 rounded-full mb-4 tracking-wide">
            <i className="ri-double-quotes-l mr-1"></i>
            Testimonials
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Trusted by Thousands of Shoppers
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Real feedback from international shoppers who use Superbuy Spreadsheet daily
          </p>
        </div>

        {/* First Row: 3 cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
          {testimonials.slice(0, 3).map((t) => (
            <div
              key={t.name}
              className="p-6 md:p-7 rounded-2xl bg-background-100/70 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
              <div className="text-accent-400 mb-3">
                <i className="ri-double-quotes-l text-2xl"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>

        {/* Second Row: 2 cards (one wide, one column of two small) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Wide testimonial with image */}
          <div className="md:col-span-2 relative rounded-2xl overflow-hidden">
            <img
              src={testimonials[3].image}
              alt={testimonials[3].name}
              className="w-full h-full min-h-[220px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-6 md:p-7 max-w-md">
              <p className="text-sm text-background-50/90 leading-relaxed mb-3 line-clamp-3">
                {testimonials[3].text}
              </p>
              <div className="text-sm font-semibold text-background-50">{testimonials[3].name}</div>
              <div className="text-xs text-background-50/70">{testimonials[3].role}</div>
            </div>
          </div>

          {/* Stack of two small cards */}
          <div className="flex flex-col gap-5">
            <div className="flex-1 p-5 rounded-2xl bg-background-100/70 border border-background-200/60 flex flex-col justify-center">
              <div className="text-accent-400 mb-2">
                <i className="ri-double-quotes-l text-xl"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3 line-clamp-3">
                {testimonials[4].text}
              </p>
              <div className="flex items-center gap-2 mt-auto">
                <img
                  src={testimonials[4].image}
                  alt={testimonials[4].name}
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-xs font-semibold text-foreground-900">{testimonials[4].name}</div>
                  <div className="text-xs text-foreground-500">{testimonials[4].role}</div>
                </div>
              </div>
            </div>
            <div className="flex-1 p-5 rounded-2xl bg-background-100/70 border border-background-200/60 flex flex-col justify-center">
              <div className="text-accent-400 mb-2">
                <i className="ri-double-quotes-l text-xl"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3 line-clamp-3">
                The Superbuy Spreadsheet is my daily go-to resource. The quality comparison guides and QC photo tips alone have saved me from countless bad purchases.
              </p>
              <div className="flex items-center gap-2 mt-auto">
                <img
                  src={testimonials[0].image}
                  alt="Sarah M."
                  className="w-9 h-9 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-xs font-semibold text-foreground-900">Sarah M.</div>
                  <div className="text-xs text-foreground-500">Lifestyle Blogger</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}